import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Booking = lazy(() => import('../pages/booking/page'));
const Reserve = lazy(() => import('../pages/reserve/page'));
const DeliveryReserve = lazy(() => import('../pages/delivery-reserve/page'));
const ServiceSelect = lazy(() => import('../pages/service-select/page'));
const Line = lazy(() => import('../pages/line/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const About = lazy(() => import('../pages/about/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/booking',
    element: <Booking />,
  },
  {
    path: '/reserve',
    element: <Reserve />,
  },
  {
    path: '/delivery-reserve',
    element: <DeliveryReserve />,
  },
  {
    path: '/service-select',
    element: <ServiceSelect />,
  },
  {
    path: '/line',
    element: <Line />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
